import {createBrowserRouter, RouterProvider} from "react-router-dom";
import HomePage from "./pages/HomePage";
import RootLayout from "./pages/RootLayout";
import ErrorPage from "./pages/ErrorPage";
import PersonalIntakePage from "./pages/PersonalIntakePage";
import ServicesPage from "./pages/ServicesPage";
import BusinessIntakePage from "./pages/BusinessIntakePage";

const router = createBrowserRouter([
    {
        path:'/',
        element: <RootLayout/>,
        children: [
            {index: true, element: <HomePage/>},
            {path: 'intake', element: <PersonalIntakePage/>},
            {path: 'businessIntake', element: <BusinessIntakePage/>},
            {path: 'services', element: <ServicesPage/>}
        ],
        errorElement: <ErrorPage/>
    }
]);

function App() {
    return <RouterProvider router={router}/>
}

export default App;
